export const TEMPLATE_ID_KEY = 'id';
export const TEMPLATE_ATTACHMENT_KEY = 'attachments';
export const TEMPLATE_ENCODING_KEY = 'encoding';
export const TEMPLATE_FUEL_CARD_PROVIDER_ID_KEY = 'fuelCardProvider';
export const TEMPLATE_MIME_TYPE_GROUP_KEY = 'mimeTypeGroup';

export const TEMPLATE_TABLE_KEY = 'v2/expense/import-template';
export const TEMPLATE_TABLE_SETTINGS = 'import_template_v2';
export const TEMPLATE_QUERY_KEY = 'importTemplate';

export const TableSettingsKeys = {
  attachments: 'table_list.columns.importTemplates.attachments',
  encoding: 'table_list.columns.importTemplates.encoding',
  fuelCardProvider: 'table_list.columns.importTemplates.fuelCardProviderId',
  mimeTypeGroup: 'table_list.columns.importTemplates.mimeTypeGroupId',
};
